import "./modules/global";
import Splide from "@splidejs/splide";

import { initNewsSlider } from "./modules/news-slider";

// Initialize news slider
window.addEventListener("load", () => {
	const newsSection = document.querySelector(".news-section");
	const newsParagraph = newsSection.querySelectorAll(".news-section p");
	const mobileQuery = window.matchMedia("(max-width: 767px)");

	if (newsParagraph && mobileQuery.matches) {
		newsParagraph.forEach((paragraph) => {
			paragraph.textContent = paragraph.textContent.slice(0, 35) + "...";
		});
	}

	initNewsSlider();

	const blogsSlider = new Splide(".blogs .splide", {
		type: "loop",
		autoplay: false,
		pauseOnHover: true,
		pauseOnFocus: true,
		speed: 1200,
		arrows: true,
		gap: 5,
		pagination: false,
		perPage: 1,
		perMove: 1,
		height: 500,
	});

	blogsSlider.mount();
});
